import {IKuPiper} from '@/middleware/types';

import {rteNotifyCommentAction, rteNotifyType} from '@/constants/document/notification';
import * as store from '@/store';
import {isInKuShare} from '@/utils/urlUtils';
import {getIsBaikeRepo} from '@/pages/baike/utils';
import DocPanel from './DocPanel';
import {resetCommentBg} from './DocPanel/utils/panelStatus';
import {RightSidebarWidth} from '@/constants/document/doc';

export default class QuestionAnswerPlugin {
    options: {
        name: string;
    };

    constructor(options?: any) {
        this.options = {
            name: 'QuestionAnswerPlugin',
            ...options,
        };
    }

    apply(kuPiper: IKuPiper) {
        // 注册插槽
        kuPiper.registerSlots({
            options: this.options,
            slots: [
                {
                    type: 'Normal',
                    action: 'Add',
                    slot: {
                        scope: kuPiper.slotScopeMap.DocumentEditor,
                        position: kuPiper.slotPositionMap.DocumentEditor.EditorTop,
                    },
                    Comp: DocPanel,
                },
            ],
        });

        // 拦截RTE通知
        kuPiper.registerProxy(kuPiper.proxyNameMap.onRteNotifyProxy, {
            options: this.options,
            fn: (callback: any, ...args: any) => {
                console.log(args);
                const data = args[0] || {};
                if (data.type === rteNotifyType.COMMENT && data.action === rteNotifyCommentAction.INIT) {
                    // 如果当前展示划线评论假背景，在评论完成初始化后进行重置
                    resetCommentBg();
                }
                return callback && callback(...args);
            },
        });

        // 拦截 editor pluginOptions参数
        kuPiper.registerProxy(kuPiper.proxyNameMap.editorPluginOptionsProxy, {
            options: this.options,
            fn: (callback: any, ...args: any) => {
                const pluginOptions = callback(...args);

                const curDocument = store.getCurDocument();
                const isOpenAiChat = !isInKuShare()
                    && !getIsBaikeRepo(curDocument?.repositoryGuid!)
                    && store.getSDKShowAIPanel();

                // 此处设置customWidth是因为新建文档时，划线评论区域的宽度不正常
                return {
                    ...pluginOptions,
                    comment: {
                        ...pluginOptions?.comment || {},
                        newUI: isOpenAiChat,
                        customWidth: isOpenAiChat ? RightSidebarWidth : undefined,
                    },
                };
            },
        });
    }
}
